export const FINANCE_TAB_IDS = [
  'a_receber',
  'a_pagar',
  'concluido',
  'cancelado',
];

const TAB_STORAGE_KEY = 'real_estate_finance_tab';

const storage = () =>
  typeof window === 'undefined' ? null : window.localStorage;

export const financeNavigationItems = t => [
  {
    id: 'a_receber',
    label: t('REAL_ESTATE_FINANCE.TABS.RECEIVABLE'),
    icon: 'i-lucide-wallet',
  },
  {
    id: 'a_pagar',
    label: t('REAL_ESTATE_FINANCE.TABS.PAYABLE'),
    icon: 'i-lucide-hand-coins',
  },
  {
    id: 'concluido',
    label: t('REAL_ESTATE_FINANCE.TABS.COMPLETED'),
    icon: 'i-lucide-circle-check',
  },
  {
    id: 'cancelado',
    label: t('REAL_ESTATE_FINANCE.TABS.CANCELED'),
    icon: 'i-lucide-trash-2',
  },
];

export const normalizeFinanceTab = value =>
  FINANCE_TAB_IDS.includes(value) ? value : FINANCE_TAB_IDS[0];

export const readFinanceTab = () => {
  const saved = storage()?.getItem(TAB_STORAGE_KEY);
  if (saved) return normalizeFinanceTab(saved);

  const legacyIndex = Number(storage()?.getItem('financeiro_submenu'));
  return normalizeFinanceTab(FINANCE_TAB_IDS[legacyIndex]);
};

export const persistFinanceTab = value => {
  storage()?.setItem(TAB_STORAGE_KEY, normalizeFinanceTab(value));
};
